import React, { useEffect, createElement } from 'react';
export function GoogleTagManager() {
  useEffect(() => {
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    // Create and append GTM script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://2505.faithandfig.com/gtm.js?id=GTM-M3K5WDNJ';
    // Append to head instead of trying to insert before first script
    document.head.appendChild(script);
    // Cleanup function
    return () => {
      // Optional: remove script on unmount if needed
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return null;
}